import React, { useEffect } from "react";

import "./layout.css";
import "../table/table.css";

import Sidebar from "../sidebar/Sidebar";
import TopNav from "../topnav/TopNav";
import Routes from "../Routes";

import { BrowserRouter, Route } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import ThemeAction from "../../redux/actions/ThemeAction";
import useAuth from "../../hooks/useAuth";
import { getLocalUser } from "../../utils/helper";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { PermissionAccessControlProvider } from "../../context/PermissionAccessControl";

const ThemeMUI = ({ children }) => {
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      secondary: createColor("#cccccc"),
      danger: createColor("#5DBA40"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

const Layout = () => {
  const { setAuth } = useAuth();

  const themeReducer = useSelector((state) => state.ThemeReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    const themeClass = localStorage.getItem("themeMode", "theme-mode-light");

    const colorClass = localStorage.getItem("colorMode", "theme-mode-light");

    const currentUser = getLocalUser();

    setAuth(currentUser);

    dispatch(ThemeAction.setMode(themeClass));

    dispatch(ThemeAction.setColor(colorClass));
  }, [dispatch, setAuth]);

  return (
    <BrowserRouter>
      <PermissionAccessControlProvider>
        <Route
          render={(props) => (
            <ThemeMUI>
              <div
                className={`layout ${themeReducer.mode} ${themeReducer.color}`}
              >
                <Sidebar {...props} />
                <div className="layout__content">
                  <TopNav />
                  <div className="layout__content-main">
                    <Routes />
                  </div>
                </div>
              </div>
            </ThemeMUI>
          )}
        />
      </PermissionAccessControlProvider>
    </BrowserRouter>
  );
};

export default Layout;
